import { render, staticRenderFns } from "./outBoundList.vue?vue&type=template&id=7e96a10b&scoped=true&"
import script from "./outBoundList.vue?vue&type=script&lang=js&"
export * from "./outBoundList.vue?vue&type=script&lang=js&"
import style0 from "./outBoundList.vue?vue&type=style&index=0&id=7e96a10b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e96a10b",
  null
  
)

export default component.exports